import type { KadeweUser } from "~/types";

export default defineNuxtRouteMiddleware((to) => {
    const user = useSanctumUser<KadeweUser>();
    const localePath = useLocalePath();

    if (!user.value?.student.has_to_verify) {
        console.warn("Student not verified: User already verified their student id", to.path);
        return navigateTo(localePath("/portal/card"));
    }
});
